import React from "react";
import { Link } from "react-router-dom";

const SignupBanner = () => {
  return (
    <section className="section bg-primary">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center">
            <div
              className="card border-0 shadow-lg"
              style={{
                borderRadius: "20px",
                background:
                  "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.98) 100%)",
              }}
            >
              <div className="card-body p-5">
                <h2 className="mb-3">
                  Build. Integrate. Scale with Formax Pay.
                </h2>
                <p className="text-muted mb-4">
                  Partner with Formax Pay to build secure, scalable, and
                  compliant payment solutions for your business
                </p>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  <Link
                    to="https://app.formaxpay.com/partner-signup"
                    className="btn btn-primary btn-lg px-4 py-3"
                  >
                    Sign Up Now <i className="fas fa-user-plus ms-2"></i>
                  </Link>

                  <Link
                    to="https://developers.formaxpay.com"
                    className="btn btn-outline-primary btn-lg px-4 py-3"
                  >
                    View API Documentation <i className="fas fa-book ms-2"></i>
                  </Link>
                </div>
                <p className="text-muted small mt-4 mb-0">
                  Simple onboarding • Complete API documentation • Dedicated
                  support
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignupBanner;
